import _ from "lodash";
import useSWR from "swr";

import api from "../api3";
import usePageData from "./usePageData";

export default function useApiSwr(key, params, optionsProp = {}) {
  const pageData = usePageData(key, params);
  const defaultOptions = { revalidateOnFocus: false, revalidateOnMount: false };

  const options = _.defaults(optionsProp || {}, defaultOptions);
  options.initialData = pageData || optionsProp.initialData;

  const url = key && !pageData ? api.getFullUrl(key, params) : null;

  return useSWR(
    url,
    async () => {
      // console.log("FETCHING", { url, params });
      const fetchRes = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (fetchRes.status === 401) {
        window.location.href = `/login/?redirect=${window.location.pathname}`;

        return;
      }

      return fetchRes
        .json()
        .then(res => {
          // console.log("API RESPONSE", { url, params, data: res.data || res });
          return options.raw || !res.data ? res : res.data;
        })
        .catch(res => {
          console.log("API ERROR", url, params, res);
          return null;
        });
    },
    { suspense: false, ...options }
  );
}
